const Logo = ({ className }: { className?: string }) => {
  return (
    <div className={"flex-center w-20 h-14 shrink-0" + (className ? ` ${className}` : "")}>
      {/* Use CSS to swap logos based on `html[data-theme=...]` (no JS needed). */}
      <img
        src="/assets/images/logo/logo.png"
        alt="Logo"
        className="object-contain w-full h-full dark:hidden"
      />
      <img
        src="/assets/images/logo/logo-dark.png"
        alt="Logo"
        className="object-contain w-full h-full hidden dark:block"
      />
    </div>
  );
};

export default Logo;
